import { AuthProvider } from './auth/AuthContext';
import Routes from './routes';
import './output.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css'
import SessionTimeoutHandler from './components/SessionTimeoutHandler';
import { ThemeProvider, useTheme } from './theme/ThemeContext';

function AppContent(): React.JSX.Element {
    const { theme } = useTheme();

    return (
        <AuthProvider>
            <SessionTimeoutHandler />
            <Routes />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                theme={theme}
            />
        </AuthProvider>
    );
}

function App(): React.JSX.Element {
    return (
        <ThemeProvider>
            <AppContent />
        </ThemeProvider>
    );
}

export default App;
